// Import Firebase functions
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getFirestore, setDoc, doc, getDoc, updateDoc, collection, query, where, getDocs, addDoc, deleteDoc, onSnapshot, serverTimestamp } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBz7MIRif0oIE5AgifUBb3JKmLNwD-mp8Q",
    authDomain: "quizzen-online.firebaseapp.com",
    projectId: "quizzen-online",
    storageBucket: "quizzen-online.firebasestorage.app",
    messagingSenderId: "222889694855",
    appId: "1:222889694855:web:8a2ae06243573d53260a22",
    measurementId: "G-NSYB9E8JVS"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export { setDoc, doc, getDoc, updateDoc, collection, query, where, getDocs, addDoc, deleteDoc, onSnapshot, serverTimestamp };
